import { getFolderDeviationsWidgetConfig } from './widgets/FolderDeviations/widgetConfig';
import { getFoldersWidgetConfig } from './widgets/Folders/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';

export const getGallectionWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  folders: getFoldersWidgetConfig({ t, dispatch }),
  folderDeviations: getFolderDeviationsWidgetConfig({ t, dispatch }),
});
